type BookingRouteVariant = 'beta' | 'canonical';
export const bookingListPath = (): string => '/bookings';
export const bookingDetailPath = (id: number, variant: BookingRouteVariant = 'canonical'): string =>
  `${variant === 'beta' ? '/booking-beta' : '/booking'}/${id}`;
/** A bounded, same-origin booking return path, never an arbitrary redirect. */
export const getBookingReturnPath = (input: unknown, bookingId?: number): string | null => {
  if (typeof input !== 'string') {
    return null;
  }
  const match = /^\/(booking|bookings)\/([1-9]\d*)$/.exec(input);
  if (
    !match ||
    !Number.isSafeInteger(Number(match[2])) ||
    (bookingId !== undefined && Number(match[2]) !== bookingId)
  ) {
    return null;
  }
  return input;
};
/** A bounded, same-origin conversation path a booking may return to. */
export const getChatReturnPath = (input: unknown): string | null =>
  typeof input === 'string' && /^\/inbox\/[1-9]\d{0,15}\/chat$/.test(input) ? input : null;
export const bookingIntegrationPath = (id: number, destination: 'payment' | 'rwb-review'): string =>
  `/booking/${id}/${destination}?${new URLSearchParams({
    returnTo: bookingDetailPath(id),
  }).toString()}`;
export const isBetaBookingsRoute = (path: string): boolean =>
  /^\/(bookings-beta|booking-beta)(\/|$)/.test(path);
